import { observable, action } from 'mobx';
import { plainToClassFromExist } from 'class-transformer';
import QuestionService from '../../service/QuestionService';
import PostsService from '../../service/PostsService';

class Video {
    public cover: string;
    public duration: string;
    public videoId: string;
    public videoRes: string;
    public videoUrlSource: string;
}
class Img {
    @observable public url: string;
    @observable public imageRes: string;
}
class AddQuestion {
    @observable public name: string;
    @observable public content: string;
    @observable public images: Img[] = [];
    @observable public video: Video | null;
    @observable public type: number = 0;  // 0:图文 1:视频
    @action public set(obj) {
        plainToClassFromExist(this, obj);
    }
}

// request publish
class PublicQuestion {
    @action public set(param) {
        return QuestionService.publish(param).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
    @action public set_v2(param) {  // v2接口
        return QuestionService.publish_v2(param).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
}

// answerUnit

class AnswerLiUnit {
    public answerSum: number; // 回答量
    public avatar: string;   // 头像
    public browseSum: number; // 浏览量
    public collectSum: number; // 收藏数
    public favourSum: number; // 点赞数
    public questionProductId: number; // 问题id
    public id: number; // id
    public title: string; // 标题：文章，专题,问题名称
    public releaseTime: number; // 内容发布时间
}

// request list
class AnswerList {
    @observable public results: AnswerLiUnit[] = [];
    @observable public totalCount: number;
    @observable public pageNo: number = 1;
    @observable public pageSize: number = 10;
    @observable public dataStatus: string;
    @action public get(param) {
        this.dataStatus = 'pending';
        return QuestionService.searchList(param).then((res) => {
            this.dataStatus = 'done';
            // plainToClassFromExist(this, res);
            this.results = res.results;
            this.totalCount = res.totalCount;
            this.pageNo = res.pageNo;
            this.pageSize = res.pageSize;
            return res;
        }).catch((err) => {
            this.dataStatus = 'error';
        });
    }
    // 是否可以回答
    @action public checkAnswer(questionProductId) {
        return QuestionService.checkAnser(questionProductId).then((res) => {
            return res;
        });
    }
}

class MyQuestionList {
    @observable public results: AnswerLiUnit[] = [];
    @observable public totalCount: number;
    @observable public pageNo: number = 1;
    @observable public pageSize: number = 10;
    @observable public dataStatus: string;
    @action public get(param) {
        this.dataStatus = 'pending';
        return QuestionService.myQuestionList(param).then((res) => {
            this.dataStatus = 'done';
            // plainToClassFromExist(this, res);
            this.results = res.results;
            this.totalCount = res.totalCount;
            this.pageNo = res.pageNo;
            this.pageSize = res.pageSize;
            return res;
        }).catch((err) => {
            this.dataStatus = 'error';
        });
    }
}

// request detail
class GetDetail {
    @observable public id: number; // 唯一id
    @observable public questionProductId: number; // 唯一问题id
    @observable public title: string; // 标题：文章，专题,问题名称
    @observable public description: string;
    @observable public images: Img[] = [];
    @observable public nickname: string;
    @observable public releaseTime: number;
    @observable public avatar: string;
    @observable public videoUrlHigh: string;
    @observable public status: number;
    @observable public type: number;
    @observable public imageUrls: any[] = [];
    @action public get(id) {
        return QuestionService.getDetail(id).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
    @action public del(id, fn) {
        return PostsService.delPosts(id).then((res) => {
            // plainToClassFromExist(this, res);
            fn && fn();
            return res;
        });
    }
}
export { AddQuestion, PublicQuestion, AnswerList, GetDetail, MyQuestionList };
